<div class="flex flex__align-items--center flex--column">
  <h3 textWeight="bold" textColor="black-two">Proposal new discount</h3>

  <form [formGroup]="dataForm" (ngSubmit)="send()" >
    <div class="forgot-password__form flex flex--row flex--box">
      <div class="flex flex--column">
        <div class="flex">
          <mat-form-field class="px-2">
            <input type="number" step="1" min="0" max="100" placeholder="Discount %" matInput formControlName="discount">
          </mat-form-field>
          <mat-form-field class="px-2">
            <input type="number" step="5" min="0" max="10000" placeholder="New Price" matInput formControlName="priceWithDiscount">
          </mat-form-field>
        </div>
        <div class="flex">
          <mat-form-field class="px-2">
            <input
              matInput
              [matDatepicker]="pickDate"
              placeholder="Pickup Date"
              formControlName="pickDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickDate></mat-datepicker>
            <mat-error *ngIf="controls.pickDate.hasError('required')">
              Pickup date is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="px-2">
            <input
              matInput
              [matDatepicker]="deliveryDate"
              placeholder="Delivery Date"
              formControlName="deliveryDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="deliveryDate"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #deliveryDate
            ></mat-datepicker>
            <mat-error *ngIf="controls.deliveryDate.hasError('required')">
              Delivery date is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div> 
    <div md-dialog-actions class="actions flex">
      <button class="actions--button flex--box" mat-raised-button color="warn" (click)="dialogRef.close()">Cancel</button>
      <button type="submit" class="actions--button flex--box" mat-raised-button
      color="primary">Send</button>
    </div>
  </form>
</div>
